import axios from "axios";

/**
 * Download a file from a URL with an auth token and save it with the given fileName.
 * @param {string} url - The file URL to download
 * @param {string} token - The auth token to use
 * @param {string} fileName - The name to save the file as
 */
export const downloadFile = async (url, token, fileName) => {
  try {
    const response = await axios.get(url, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error("Download failed", err);
  }
};
